<template>
  <keep-alive include="teacherList"><router-view /></keep-alive>
</template>
<script>
export default {}
</script>